import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const LEGACY_API_ORIGIN = "http://localhost:8001";
const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);

const resolveApiUrl = (url) => {
  if (typeof url !== "string" || !url.startsWith(`${LEGACY_API_ORIGIN}/api`)) {
    return url;
  }

  const configuredApiBase = (process.env.REACT_APP_API_BASE_URL || "").trim().replace(/\/$/, "");
  if (configuredApiBase) {
    return `${configuredApiBase}${url.slice(LEGACY_API_ORIGIN.length)}`;
  }

  // Production'da hardcoded localhost URL'lerini same-origin /api'ye çevir.
  if (!LOCAL_HOSTS.has(window.location.hostname)) {
    return url.replace(LEGACY_API_ORIGIN, "");
  }

  return url;
};

const originalFetch = window.fetch.bind(window);
window.fetch = (input, init) => {
  if (typeof input === "string") {
    return originalFetch(resolveApiUrl(input), init);
  }

  if (input instanceof Request) {
    return originalFetch(new Request(resolveApiUrl(input.url), input), init);
  }

  return originalFetch(input, init);
};

// React DevTools uyarısını kaldır
const filterDevToolsMessage = (args) => {
  if (args[0] && typeof args[0] === 'string' && 
      (args[0].includes('Download the React DevTools') || 
       args[0].includes('react.dev/link/react-devtools'))) {
    return true;
  }
  return false;
};

const originalLog = console.log;
const originalInfo = console.info;
const originalWarn = console.warn;

console.log = (...args) => {
  if (filterDevToolsMessage(args)) return;
  originalLog.apply(console, args);
};

console.info = (...args) => {
  if (filterDevToolsMessage(args)) return;
  originalInfo.apply(console, args);
};

console.warn = (...args) => {
  if (filterDevToolsMessage(args)) return;
  originalWarn.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

